import React from 'react';
import { OpenInNewTab } from 'seagull/icons';
import ExternalLinkButton from "../../ExternalLinkButton";
export const TimeActivityExternalLink = _ref => {
  let {
    timeActivity
  } = _ref;
  return /*#__PURE__*/React.createElement(ExternalLinkButton, {
    href: timeActivity.url,
    testid: "time-activity-".concat(timeActivity.id, "-external-link"),
    tooltip: {
      title: 'Open Time Activity in QuickBooks Online',
      placement: 'top'
    },
    openInNewTab: true
  }, /*#__PURE__*/React.createElement(OpenInNewTab, null));
};